import { render, staticRenderFns } from "./SelectAdminPopup.vue?vue&type=template&id=4b577fba"
import script from "./SelectAdminPopup.vue?vue&type=script&lang=js"
export * from "./SelectAdminPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports